import { AnimatePresence, motion } from "framer-motion";
import { Flame, X } from "lucide-react";
import { useEffect, useState } from "react";
import { useSim } from "../lib/store";

export function NarrativeGuide() {
  const activeEruption = useSim((s) => s.activeEruption);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (activeEruption) setDismissed(false);
  }, [activeEruption?.name]);
  const show = !!activeEruption && !dismissed;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="narrative-guide"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -30 }}
          className="fixed bottom-32 left-4 z-30 w-[90vw] max-w-sm p-4 rounded-2xl bg-zinc-950/85 backdrop-blur-xl border border-orange-500/40 shadow-[0_16px_48px_rgba(0,0,0,0.8),0_0_28px_rgba(249,115,22,0.15)]"
        >
          <button data-testid="dismiss-narrative" onClick={() => setDismissed(true)} className="absolute top-2 right-2 p-1 rounded-md text-zinc-500 hover:text-white hover:bg-white/10">
            <X className="h-4 w-4" />
          </button>
          <div className="flex items-center gap-2 mb-2">
            <div className="relative">
              <div className="absolute inset-0 rounded-full blur-md bg-orange-500/50" />
              <Flame className="relative h-5 w-5 text-orange-400" />
            </div>
            <h4 className="text-sm font-semibold text-orange-200 uppercase tracking-wide">Volcanic Coupling — {activeEruption.name}</h4>
          </div>
          <p className="text-xs text-zinc-300 leading-relaxed">
            Great earthquakes (Mw 7.0+) can <span className="text-orange-300">unclamp</span> a nearby volcano's magma
            plumbing. The sudden static-stress change and violent shaking open fractures and depressurise the chamber —
            dissolved gases expand and drive magma upward. Historically, ruptures like <span className="text-white">Chile 1960</span>
            {" "}were followed by eruptions within days. Here, the seismic strain relief has triggered a live eruption:
            glowing <span className="text-orange-400">lava</span> and a rising <span className="text-zinc-400">ash</span> plume, both feeding the Total Energy Release.
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
